import React from 'react';

interface IPhoneIconProps {
	size?: string;
}

export const Phone = ({ size = '24' }: IPhoneIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.7022 20.2268L13.7129 20.233C15.6578 21.4713 18.2018 21.1923 19.8321 19.5619L20.5201 18.8739C21.16 18.2333 21.16 17.1954 20.5201 16.5548L17.6214 13.6578C16.9808 13.018 15.9429 13.018 15.3023 13.6578V13.6578C14.995 13.9655 14.578 14.1384 14.1431 14.1384C13.7083 14.1384 13.2913 13.9655 12.984 13.6578L8.34572 9.01866C7.70587 8.37801 7.70587 7.34016 8.34572 6.69952V6.69952C8.65338 6.39223 8.82626 5.97523 8.82626 5.54039C8.82626 5.10555 8.65338 4.68855 8.34572 4.38126L5.4479 1.47988C4.80725 0.840038 3.7694 0.840038 3.12875 1.47988L2.44074 2.16789C0.810751 3.79827 0.531417 6.34183 1.76873 8.28709L1.77585 8.29776C4.95226 12.9999 9.00082 17.0494 13.7022 20.2268V20.2268Z"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
